/**
 * sidebarCache — Invalidación proactiva del caché del Sidebar.
 *
 * El <Sidebar> guarda menús y config en sessionStorage bajo estas claves
 * para renderizar instantáneamente en cargas posteriores dentro de la misma
 * sesión. Cuando un Admin edita menús (/menus) o config general
 * (/configuracion-general), debemos invalidar el caché para que el próximo
 * render refresque desde la API en lugar de usar datos stale.
 *
 * Uso:
 *   import { invalidateSidebarMenus, invalidateSidebarConfig } from '../utils/sidebarCache';
 *   await menusAPI.update(id, data);
 *   invalidateSidebarMenus();
 */
const CACHE_KEY_MENUS = 'ibc_sidebar_menus_v1';
const CACHE_KEY_CONFIG = 'ibc_sidebar_config_v1';

export const invalidateSidebarMenus = () => {
  try { sessionStorage.removeItem(CACHE_KEY_MENUS); } catch { /* sessionStorage deshabilitado */ }
};

export const invalidateSidebarConfig = () => {
  try { sessionStorage.removeItem(CACHE_KEY_CONFIG); } catch { /* sessionStorage deshabilitado */ }
};
